import { render, staticRenderFns } from "./group_apply.vue?vue&type=template&id=06d2c5fc&scoped=true"
import script from "./group_apply.vue?vue&type=script&lang=js"
export * from "./group_apply.vue?vue&type=script&lang=js"
import style0 from "./group_apply.vue?vue&type=style&index=0&id=06d2c5fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d2c5fc",
  null
  
)

export default component.exports